import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AppContext, useAppContext } from "../libs/contextLib";
import Button from 'react-bootstrap/Button';
import Form from "react-bootstrap/Form";
import Address from "../components/Address";
import InfoIcon from '../components/InfoIcon';
//import ImageProfile from '../components/ImageProfile';
import { onError } from "../libs/errorLib";
import { s3PublicUpload } from "../libs/awsLib";
import { getSortedDecalForDisplay } from "../libs/utilsLib"
import { saveBusiness } from "../services/Business";
import classificationsDisplayMap from "../constants/classificationsDisplayMap";
import config from '../config';
import { useLoader } from '../context/LoaderContext';
import "./Sticker.css";

export default function RequestSticker() {
    const { isAuthenticated, business, setBusiness } = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const [hasPhysicalLocation, setHasPhysicalLocation] = useState(false);
    const [otherAddresses, setOtherAddresses] = useState([]);
    const [decalTemplateImageUrl, setDecalTemplateImageUrl] = useState("");
    const [decalImageUrl, setDecalImageUrl] = useState("");
    const [decalImageBlob, setDecalImageBlob] = useState("");
    const history = useHistory();
    const [,setLoading] = useLoader();

    useEffect(() => {
        setLoading(isLoading);
    }, [isLoading, setLoading]);

    useEffect(() => {
        //ensures window scrolls to top when loading this page
        window.scrollTo(0, 0);
        
        async function onLoad() {
            if (!isAuthenticated) {
                return;
            }

            if (business && business.otherAddresses) {
                setOtherAddresses(business.otherAddresses);
            }

            if (business && business.decalImageUrl) {
                //break cache since we need to edit the image
                var randomNum = new Date().getTime();
                let blob = await fetch(business.decalImageUrl+"?"+randomNum).then(r => r.blob());
                setDecalImageBlob(blob);
            }

            if (business.hasPhysicalLocation) {
                setHasPhysicalLocation(true)
            } 

            //Check classifications to determine which decal to show as template
            if (business.classifications && business.classifications.length > 0) {
                var sortedPreferredClassifications = getSortedDecalForDisplay(business.classifications);
                var classification = sortedPreferredClassifications[0];
                var decalTemplateImageUrl = classificationsDisplayMap[classification].image;
                setDecalTemplateImageUrl(decalTemplateImageUrl);
            }
            setIsLoading(false);
        }
  
        onLoad();
    }, [isAuthenticated, business]);

    async function handleSubmit(event, destination) {
        event.preventDefault();
        event.stopPropagation();

        setIsLoading(true);
        try {
            const params = {};

            //check if any data needs to be saved.  If not, no need to do an extra call to save
            //TODO: Need to determine if we want to call backend to save or not.  if no changes, we can skip a call
            let hasChanges = true;
            if (hasPhysicalLocation !== undefined || hasPhysicalLocation !== null) {
                params["hasPhysicalLocation"] = hasPhysicalLocation;
            }
            if (otherAddresses.length < 1) {
                //set field to null so that we can persist it still
                params["otherAddresses"] = null;
            } else {
                params["otherAddresses"] = otherAddresses;
            }

            if (decalImageUrl !== null && decalImageUrl !== "" && decalImageUrl !== business.decalImageUrl) {
                params["decalImageUrl"] = decalImageUrl;
                hasChanges = true;
            }

            //Saving a call to backend unless there are changes
            if (hasChanges) {
                await saveBusiness(business.businessId, params);

                //update business stored in appContext once save is successful
                //also saving a call to refresh business object (for now) since changes are easy to track
                business.otherAddresses = otherAddresses;
                business.decalImageUrl = decalImageUrl;
                business.hasPhysicalLocation = hasPhysicalLocation;
                setBusiness(business);
            }
            setIsLoading(false);

            //go to destination
            if (destination === "next") {
                history.push("stamps");
            } else if (destination === "home") {
                history.push("home");
            } 
        } catch (e) {
            onError(e);
            setIsLoading(false);
        }
    }

    async function setDecalImage(output) {
        console.log("*******in setDecalImage: " + output);

        const s3FileName = output.file ? await s3PublicUpload(output.file) : null;
        console.log("******s3FileName : " + s3FileName);

        //TODO: Storing the full S3 path right now for easier retrieval.  need to look for better practices
        const imageFullUrl = "https://" + config.s3.BUCKET + ".s3.amazonaws.com/public/" + s3FileName;
        setDecalImageUrl(imageFullUrl);
    };

    function onClickRadio(e) {
        if (e && e.target.value === 'yes') {
            setHasPhysicalLocation(true)
        } else if (e && e.target.value === 'no') {
            setHasPhysicalLocation(false)
        }
    }
    return (
        <div>
            {isAuthenticated && !isLoading && (
                <div className="content">
                    <div className="contentHeader">
                        <h2>1. Order Decals</h2>
                    </div>
                    <div className="sticker">
                        { /* 1/8/2021: Take out B/W picture feature for time being
                        <div className="contentBody">
                            <div className="left-text row-bottom-20">
                                1a. Upload or take your photo (optional)
                                <InfoIcon 
                                    keyName={"profileImageInfo"}
                                    message={"If you upload a profile picture of yourself, we’ll also send you a black and white decal that you can display next to your storefront Stamp."}
                                />
                            </div>
                            <div>
                                <ImageProfile
                                    setImageObject={setDecalImage} 
                                    imageSrc={decalImageBlob} 
                                    decalTemplateSrc={decalTemplateImageUrl} 
                                    backgroundSrc={"https://sert-consumer.s3.amazonaws.com/images/window-sample.png"} 
                                />
                            </div>
                        </div>
                        */ }
                        <div className="contentBody">
                            <div className="left-text row-bottom-20">
                                Do you have have a physical storefront?
                                <InfoIcon 
                                    keyName={"locationInfo"}
                                    message={"We'll send your physical Sertify decals for each of your locations!"}
                                />
                            </div>
                            <div className="left-text"> 
                                <div className="mb-3">
                                    <Form.Check
                                        inline
                                        label="Yes"
                                        name="hasPhysicalLocation"
                                        type="radio"
                                        id="yes"
                                        value='yes'
                                        onClick={onClickRadio}
                                        defaultChecked={hasPhysicalLocation}
                                    />
                                    <Form.Check
                                        inline
                                        label="No"
                                        name="hasPhysicalLocation"
                                        type="radio"
                                        id="no"
                                        value='no'
                                        onClick={onClickRadio}
                                        defaultChecked={!hasPhysicalLocation}
                                    />
                                </div>
                            </div>
                        </div>
                        { hasPhysicalLocation && (
                            <div className="contentBody">
                                <div className="left-text row-bottom-20">
                                    Do you have more than one location?
                                    <InfoIcon 
                                        keyName={"locationInfo"}
                                        message={"If you have additional locations, please add them and we'll send you decals for each location!"}
                                    />
                                </div>
                                <div className="left-text"> 
                                    <div>
                                        <AppContext.Provider
                                            value={{ business, otherAddresses, setOtherAddresses }}
                                        >
                                            <Address />
                                        </AppContext.Provider>
                                    </div>

                                    
                                </div>
                            </div>
                        )}
                        <div className="pageButtons-single row-top-10">
                            {   //show Next button if user is going through onboarding for first time
                                !business.onboardingCompletionDate && (
                                    <Button variant="primary" onClick={event => handleSubmit(event, 'next')}>NEXT</Button>
                                )}
                            {   /* User has completed onboarding.  Show "Save" button instead of "Next" */
                                business.onboardingCompletionDate && (
                                    <Button variant="primary" onClick={event => handleSubmit(event, 'home')}>SAVE</Button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}